import { Modal, PasswordInput, Button, Flex, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { trpc } from '../lib/trpc';

interface PasswordChangeModalProps {
  open: boolean;
  onClose: () => void;
}

export default function PasswordChangeModal({ open, onClose }: PasswordChangeModalProps) {
  const form = useForm({
    initialValues: { currentPassword: '', newPassword: '', confirmPassword: '' },
    validate: {
      currentPassword: (v) => (v ? null : 'Required'),
      newPassword: (v) => (v ? null : 'Required'),
      confirmPassword: (v, values) =>
        v === values.newPassword ? null : 'Passwords do not match',
    },
  });

  const changePassword = trpc.admin.auth.changePassword.useMutation({
    onSuccess: () => {
      notifications.show({ color: 'green', message: 'Password changed successfully.' });
      handleClose();
    },
    onError: (err) => notifications.show({ color: 'red', message: err.message }),
  });

  function handleClose() {
    form.reset();
    onClose();
  }

  return (
    <Modal opened={open} onClose={handleClose} title="Change Password">
      <form onSubmit={form.onSubmit((values) => changePassword.mutate(values))}>
        <Stack gap="md">
          <PasswordInput label="Current Password" autoComplete="current-password" required {...form.getInputProps('currentPassword')} />
          <PasswordInput label="New Password" autoComplete="new-password" required {...form.getInputProps('newPassword')} />
          <PasswordInput label="Confirm Password" autoComplete="new-password" required {...form.getInputProps('confirmPassword')} />
          <Flex gap="sm" justify="flex-end">
            <Button type="button" variant="default" onClick={handleClose}>Cancel</Button>
            <Button type="submit" loading={changePassword.isPending}>Change Password</Button>
          </Flex>
        </Stack>
      </form>
    </Modal>
  );
}
